import React from "react";
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import { QAItemDetail } from "./SubmissionQA.js";

// Custom ItemDetailsPane for the cross-submission Q&A list (DataTable.js). DataTable.js
// fetches the row (config.getSingleItemUrl + "?Id=") and hands it to us fully loaded via
// globalContext.currentItem — this is a thin wrapper reusing the exact same QAItemDetail
// component the per-submission Q&A tab already uses, so row-click opens the same detail
// view (PDF/Details/AI tabs, edit, delete) either place.
const SubmissionQAListItemDetailsPane = ({ globalContext }) => {

    const AppContext = globalContext;

    if (!AppContext.isPaneOpen)
        return null;

    if (AppContext.isLoadingItemDetails && !AppContext.currentItem) {
        return (
            <div style={{ height: "100vh", overflow: "auto" }} className="slide-pane-full-width open">
                <div className="content">
                    <div style={{ textAlign: "center", marginTop: "40px" }}><LoadingSpinnerImage /></div>
                </div>
            </div>
        );
    }

    if (!AppContext.currentItem)
        return null;

    return (
        <div style={{ height: "100vh", overflow: "auto" }} className="slide-pane-full-width open">
            <div className="content">
                <QAItemDetail
                    item={AppContext.currentItem}
                    submissionId={AppContext.currentItem.SubmissionId}
                    userRole={AppContext.userRole}
                    AppContext={AppContext}
                    onBack={AppContext.closePane}
                    onUpdate={(updated) => {
                        AppContext.setCurrentItem(updated);
                        AppContext.setData(AppContext.data.map((row) => row.Id === updated.Id ? { ...row, ...updated } : row));
                    }}
                    onDelete={() => fetch(`/umbraco/api/SubmissionQA/QA?submissionId=${AppContext.currentItem.SubmissionId}&qaId=${AppContext.currentItem.Id}`, { method: "DELETE" })
                        .then((response) => {
                            if (!response.ok) throw new Error("Network response was not ok");
                            return response.json();
                        })
                        .then(() => {
                            AppContext.setData(AppContext.data.filter((row) => row.Id !== AppContext.currentItem.Id));
                            AppContext.updateListTotalCount();
                            AppContext.closePane();
                        })}
                />
            </div>
        </div>
    );
};

export default SubmissionQAListItemDetailsPane;
